<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <div class="columns">
        <div class="column img-after">
          <img
            src="../assets/images/rdb-logo 3.png"
            alt="nsb-ekyc-logo"
            class="nsb_kyc_logo"
          />
        </div>
      </div>
    </transition>
    <div class="columns is-centered mt-5">
      <div class="column is-half ps-5" style="text-align: center">
        <div class="opacity-select-card card px-3 mt-3 pb-3" style="padding-top:48px;padding-bottom: 30px;">
          <transition
            appear
            @before-enter="$animations.beforeEnterAbove"
            @enter="$animations.enterAbove"
          >
            <p
              :class="`text-center mx-3 ${
                $root.selectedLanguage === `ta`
                  ? `ta-line`
                  : $root.selectedLanguage === `si`
                  ? `si-line`
                  : `en-line`
              }`"
              style="font-family: OpenSans-Bold ; padding-bottom: 10px;"
            >
              {{ $root.selectedLanguageData.welcome }}
            </p>
          </transition>
          <transition
            appear
            @before-enter="$animations.beforeEnterFade"
            @enter="$animations.enterFade"
          >
            <div>
              <p
                :class="`${
                  $root.selectedLanguage === `ta`
                    ? `ta-sub-line`
                    : $root.selectedLanguage === `si`
                    ? `si-sub-line`
                    : `en-sub-line`
                }`"
                style="font-family: OpenSans-Medium ;padding-bottom: 10px;"
              >
                {{
                  $root.selectedLanguageData
                    .firstonlineaccountopeningapplication
                }}
              </p>
              <!-- <p class="mt-4" style="font-size: 18px">
              Hello, Welcome to RDB Online Account Opening. Please select
              the language to get started.
            </p>
            <p class="mt-4" style="font-size: 17px">
              ආයුබෝවන්, RDB වෙත සාදරයෙන් පිළිගනිමු. ඔබේ ප්‍රශ්නවලට පිළිතුරු
              සැපයීම සඳහා කරුණාකර භාෂාව තෝරන්න.
            </p>
            <p class="mt-4" style="font-size: 15px">
              வணக்கம், RDBக்கு உங்களை வரவேற்கின்றோம். தொடர்வதற்கு,
              விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்.
            </p> -->
            </div>
          </transition>

          <div class="is-centered">
            <div class="columns buttons mt-2">
              <transition-group
                appear
                tag="div"
                @before-enter="$animations.beforeEnterStaggering"
                @enter="$animations.enterStaggering"
                style="display: contents"
              >
                <div
                  class="column is-12-mobile is-one-three-desktop"
                  :key="1"
                  :data-index="1"
                >
                  <!-- lang-button class removed card-content attribute added -->
                  <div
                    class="box lang-button card-content language-button-bg"
                    id="En"
                    @click="selectLang(`en`)"
                  >
                    <p class="language" style="font-family: OpenSans-Bold">En</p>
                  </div>
                  <b-radio
                    style="font-family: OpenSans-Regular"
                    @click.native="
                      () => {
                        selectLang(`en`);
                        lagUpdate();
                      }
                    "
                    native-value="en"
                    v-model="$root.selectedLanguage"
                  >
                    English
                  </b-radio>
                </div>
                <div
                  class="column is-12-mobile is-one-three-desktop"
                  :key="2"
                  :data-index="2"
                >
                  <!-- lang-button class removed card-content attribute added -->
<!--                  @click="selectLang(`si`)"-->
                  <div
                    class="box lang-button card-content"
                    id="Si"


                  >
                    <p class="language has-text-weight-bold">සිං</p>
                  </div>
                  <b-radio
                      disabled

                    style="font-family: OpenSans-Regular"
                    @click="
                      () => {
                        selectLang(`si`);
                        lagUpdate();
                      }
                    "
                    native-value="si"
                    v-model="$root.selectedLanguage"
                  >
                    Sinhala
                  </b-radio>
                </div>
                <div
                  class="column is-12-mobile is-one-three-desktop"
                  :key="3"
                  :data-index="3"
                >
                  <!-- lang-button class removed card-content attribute added -->
<!--                  @click="selectLang(`ta`)"-->
                  <div
                    class="box lang-button card-content"
                    id="Ta"

                  >
                    <p class="language has-text-weight-semibold">த</p>
                  </div>
                  <b-radio
                      disabled
                    style="font-family: OpenSans-Regular"
                    native-value="ta"
                    @click="

                      () => {
                        selectLang(`ta`);
                        lagUpdate();
                      }
                    "
                    v-model="$root.selectedLanguage"
                  >
                    Tamil
                  </b-radio>
                </div>
              </transition-group>
            </div>
            <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
            >
              <div class="mx-3 card-content is">
                <div
                  class="card-content"
                  style="display: flex; justify-content: center; padding:10px;"
                >
                  <VueRecaptcha
                    @expired="onExpire"
                    :sitekey="sitekey"
                    :load-recaptcha-script="true"
                    @verify="onVerify"
                  ></VueRecaptcha>
                </div>
                <b-button
                    :disabled=!this.robot
                  class="mt-5"
                  type="is-primary"
                  expanded
                  @click="generateNewKYCForm"

                  >{{ $root.selectedLanguageData.getStarted }}</b-button>


              </div>

            </transition>
          </div>
        </div>
      </div>

    </div>
    <br /><br />
    <div >
      <StatusCheck />
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import StatusCheck from "@/components/StatusCheck"
export default {
  name: "LanguageSelection",

  components: {
    VueRecaptcha,
    StatusCheck

  },

  data() {
    return {
      robot: false,
      previousRoute : '',
      //Live

      // sitekey:"6LepJNklAAAAAKh8SjLpKeijL1k7Z9MPmOMMJSEg",

      //Local
      //sitekey:"6LdlWNMmAAAAAGc5Pw4CZevaKsF1euFIE7vr9Baq",

      //Pm
      sitekey :"6LcAzfgmAAAAAP9K147Go3oPQMTWjFiM5BJQhhSj"
      //localhost 6LeUvtolAAAAAIajA0pGQCXyCTc3GfVybegScnCF
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
      console.log(vm.previousRoute," previousRoute")
    });
  },

  methods: {
    beforeEnter(el) {
      //console.log("before enter");
      el.style.opacity = 0;
      el.style.transform = "translateY(-50px)";
    },

    onExpire: function(response){
      //console.log('expire---------------')
      //console.log(response)
      if (response) {
        this.robot = false;
      }
    },


    onVerify: function (response) {
       //console.log('verify---------------')
       //console.log(response)
      if (response) {
        this.robot = true;
      }
    },

    enter(el, done) {
      //console.log("enter");
      this.$gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "ease",
        onComplete: done,
      });
    },

    nextPage() {
      this.$router.push("enter-name");
    },

    /**
     * This method is used to load selected language translations to the application
     * @param lang
     */
    getSelectedLanguageTranslations(lang) {
      this.$root.selectedLanguage = lang;
      if (lang === "en") {
        this.$root.selectedLanguageData = this.$root.engLanguageData;
      } else if (lang === "si") {
        this.$root.selectedLanguageData = this.$root.sinLanguageData;
      } else if (lang === "ta") {
        this.$root.selectedLanguageData = this.$root.tamLanguageData;
      }
    },
    async mountedFunction () {

      if (this.previousRoute.fullPath === '/congratulation'){
        console.log("page reloaded")
        location.reload()
      }


      const EnElement = document.getElementById("En");
      const SiElement = document.getElementById("Si");
      const TaElement = document.getElementById("Ta");
      if (this.$root.selectedLanguage === `en`) {
        EnElement.classList.add("language-button-bg");
        SiElement.classList.remove("language-button-bg");
        TaElement.classList.remove("language-button-bg");
      } else if (this.$root.selectedLanguage === `si`) {
        EnElement.classList.remove("language-button-bg");
        SiElement.classList.add("language-button-bg");
        TaElement.classList.remove("language-button-bg");
      } else if (this.$root.selectedLanguage === `ta`) {
        EnElement.classList.remove("language-button-bg");
        SiElement.classList.remove("language-button-bg");
        TaElement.classList.add("language-button-bg");
      }

      this.getCountriesList();
      await this.getKycFieldVisibility();
      // country
      window.element = this;

      this.$http
          .get("https://restcountries.com/v2/all")
          .then((response) => {
            const temp = [];
            for (const item of response.data) {
              temp.push({
                name: item.name,
                code: `+${item.callingCodes[0]}`,
                shortName: item.alpha2Code,
              });
            }
            this.$root.formDataSupport.countriesArray = temp;
          })
          .catch((error) => console.log(error));
    },


   async generateNewKYCForm() {
      if (this.robot) {
        try {
          window.element = this;

          this.$http
            .post(this.$baseURL + "/generateNewFormForNewCustomerUIForm", {})
            .then(async (response) => {
              if (response.data.success) {
                console.log(response.data.data.kyc_token);
                this.$root.formData.kyc_token = response.data.data.kyc_token;
                await this.getColorCodeData();
                this.$router.push('info-page')
              } else {
                this.$buefy.toast.open({
                  message: "Failed to generate a new kyc form",
                  type: "is-danger",
                });
              }
            });
        } catch (e) {
          this.$buefy.toast.open({
            message: "Failed to generate a new kyc form",
            type: "is-danger",
          });
        }
       } else {
         this.$buefy.toast.open({
           message: "Please check the checkbox in Recpatcha",
          type: "is-danger",
        });
      }
    },

    async getColorCodeData () {
      let kyc_token = this.$root.formData.kyc_token
      this.continueButtonIsLoading = true;
      this.$http
          .post(this.$baseURL + "/kycForm/getColorCode", {},{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            //console.log(response);

            // enable continue button after the response
            this.continueButtonIsLoading = false;

            if (response.data.success) {
              this.$root.formData.color_code1 = response.data.data.color_code1;
              this.$root.formData.color_code2 = response.data.data.color_code2;
              this.$root.formData.color_code3 = response.data.data.color_code3;
              this.$root.formData.color_code4 = response.data.data.color_code4;
              this.$root.formData.color_code5 = response.data.data.color_code5;
              this.$root.formData.color_code6 = response.data.data.color_code6;
              this.$root.formData.color_code7 = response.data.data.color_code7;
              this.$root.formData.color_code8 = response.data.data.color_code8;
              this.$root.formData.color_code9 = response.data.data.color_code9;
              this.$root.formData.color_code10 = response.data.data.color_code10;
              this.$root.formData.color_code11 = response.data.data.color_code11;
              this.$root.formData.color_code12 = response.data.data.color_code12;
              this.$root.formData.color_code13 = response.data.data.color_code13;
              this.$root.formData.color_code14 = response.data.data.color_code14;
              this.$root.formData.color_code15 = response.data.data.color_code15;
              this.$root.formData.color_code16 = response.data.data.color_code16;


            }
            else {
              this.$buefy.toast.open({
                message: "Failed to get customer auth tokens",
                type: "is-danger",
              });
            }
          }).catch((response) => {
        this.$buefy.toast.open({
          message: response.message,
          type: "is-danger",
        });
      });
    },

    selectLang(Lang) {
      const comp = this;
      const EnElement = document.getElementById("En");
      const SiElement = document.getElementById("Si");
      const TaElement = document.getElementById("Ta");
      if (Lang === `en`) {
        EnElement.classList.add("language-button-bg");
        SiElement.classList.remove("language-button-bg");
        TaElement.classList.remove("language-button-bg");
        this.$root.selectedLanguage = "en";
      }
      else if (Lang === `si`) {

        EnElement.classList.remove("language-button-bg");
        SiElement.classList.add("language-button-bg");
        TaElement.classList.remove("language-button-bg");
        this.$root.selectedLanguage = "si";
      }
      else if (Lang === `ta`) {
        EnElement.classList.remove("language-button-bg");
        SiElement.classList.remove("language-button-bg");
        TaElement.classList.add("language-button-bg");
        this.$root.selectedLanguage = "ta";
      }

      comp.getSelectedLanguageTranslations(Lang);
    },
    //function for update lage
    lagUpdate() {
      if (this.$root.selectedLanguage === "en") {
        this.$root.formData.selLang = "En";
        this.$root.selectedLanguageData = this.$root.engLanguageData;
      } else if (this.$root.selectedLanguage === "si") {
        this.$root.formData.selLang = "සිං";
        this.$root.selectedLanguageData = this.$root.sinLanguageData;
      } else if (this.$root.selectedLanguage === "ta") {
        this.$root.formData.selLang = "த";
        this.$root.selectedLanguageData = this.$root.tamLanguageData;
      }
    },

    // This function is used to load all active countries
    getCountriesList() {
      try {
        //console.log("Entered Into getCountriesList()");
        window.element = this;

        this.$http
          .post(this.$baseURL + "/getAllCountries", {})
          .then((response) => {
            //console.log(response.data);

            if (response.data.success) {
              //console.log("Loaded Countries List -------------");

              this.$root.formData.countriesList = response.data.data.countries;
              //console.log(this.$root.formData.countriesList);
            } else {
              //console.log(response.data);
              this.$buefy.toast.open({
                message: "Failed to fetch countries list",
                type: "is-danger",
              });
            }
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to fetch countries list",
          type: "is-danger",
        });
      }
    },

    // This function is used to load all active countries
    getKycFieldVisibility() {
      try {
        //console.log("Entered Into getKycFieldVisibility()");
        window.element = this;

        this.$http
          // .post(this.$baseURL + "/kycForm/getKycFieldConfig")
          .post(this.$baseURL + "/getKycFieldConfig", {})
          .then(async (response) => {
           // console.log(response.data);

            if (response.data.success) {
              // console.log(
              //     "Loaded Kyc Field visibility configurations -------------"
              // );

              this.$root.kycFieldVisibility = response.data.data.kycFieldConfig;
              //console.log(this.$root.kycFieldVisibility);
            } else {
              //console.log(response.data);
              this.$buefy.toast.open({
                message: "Failed to fetch kyc field visibility configurations",
                type: "is-danger",
              });
            }
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to fetch kyc field visibility configurations",
          type: "is-danger",
        });
      }
    },
  },

  mounted(){
    this.mountedFunction()
    console.log(this.sitekey)
  }
};
</script>
<style scoped>
.language {
  font-family: "fira800";
  font-size: 3.5rem;
  letter-spacing: 2px;
  line-height: 4rem;
  margin-inline: -2rem;
}
.lang-button {
  width: 70%;
  margin: auto;
}

.lang-button{
  border-radius: 10px;
  margin-bottom: 8px;

}





</style>
